import React from 'react';
import {HomepageSection, HomepageSectionHeader2} from '../Homepage';
import PidChart from 'App/views/Statistics/PID/PIDChart';
import PropTypes from 'prop-types';
import {process_country} from "../helper";


const category_map = [
    "Other well defined PIDs",
    "Complement deficiencies",
    "Phagocytic disorders",
    "Defects in innate immunity",
    "Autoinflammatory disorders",
    "Unclassified immunodeficiencies",
    "Combined immunodeficiencies",
    "Predominantly antibody disorders",
    "Diseases of immune dysregulation"
];

class PIDDistribution extends React.Component {
  render() {
    const generalPID = this.props.data;
    const extData = process_country("PID_distribution");

    // Add dummy diseases. Only main_category_id is looked up
    category_map.map(x => {this.props.data.push({main_category: x, count:extData[x], main_category_id: category_map.indexOf(x)+1})});

    return (
      <HomepageSection style={{position: 'relative', zIndex: 2}}>
        <HomepageSectionHeader2>
          <h2><span>{'PID distribution '}</span></h2>
        </HomepageSectionHeader2>
        <div style={{marginTop: 25, marginBottom: 25}}>
          <PidChart data={generalPID}
                    title={'Main categories'}
                    subtitle={'ESID'}
                    id={'esid_chart'}
                    drillDown={false}
                    exporting={false}
                    copyright={true}
          />
        </div>
      </HomepageSection>
    );
  }
}

PIDDistribution.propTypes = {
  data: PropTypes.array.isRequired
};

export default PIDDistribution;


// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/Sections/PIDDistribution.js